<template>
  <button class="option-btn" @click="$emit('click')">
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.option-btn {
  padding: 10px 18px;
  border-radius: 99px;
  border: 1px solid var(--fts-primary);
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s;
  color: var(--fts-primary);
}

.option-btn:hover {
  background: var(--fts-primary);
  color: #fff;
}
</style>
